The identifier for the `HiringOrganization` to toggle verification enrollment for.
